<script>
	import screenfull from 'screenfull';

	export let className = '';

	let focusHero = false;

	let isFullscreen = screenfull.isEnabled && screenfull.isFullscreen;
	if (screenfull.isEnabled) {
		screenfull.on('change', () => {
			isFullscreen = screenfull.isFullscreen;
		});
	}

	function handleMouseEnter() {
		focusHero = true;

		document.addEventListener('click', undoFocusHero);

		function undoFocusHero() {
			focusHero = false;
			document.removeEventListener('click', undoFocusHero);
		}
	}
</script>

<main class={className} class:focusHero={focusHero}>

	<header class="header">
		<a class="logo-link" href="/" title="Careful Clues Matchmaking"><img class="logo-image" src="./logo/logo-75px.png" alt="Careful Clues" /></a>
	</header>

	<section class="clue-left">
		<slot name="clue-left"></slot>
	</section>
	<section class="clue">
		<slot name="clue"></slot>
	</section>
	<section class="clue-right">
		<slot name="clue-right"></slot>
	</section>

	<section class="team one">
		<slot name="team-one"></slot>
	</section>

	<section class="core">
		<slot name="core"></slot>
	</section>

	<section class="team two">
		<slot name="team-two"></slot>
	</section>

	<section class="msg">
		<slot name="msg"></slot>
	</section>

	<section class="chat">
		<slot name="chat"></slot>
	</section>

	<footer>
		<span
			class="image-credit"
			on:mouseenter={handleMouseEnter}
			on:mouseleave={() => focusHero = false}>
				Art by <a href="https://bassilkaram.com" target="_blank">Bassil Karam</a>
		</span>
		<span class="copyright">
			<!-- Copyright CarefulClues.com &copy; {new Date().getFullYear()} -->
			<a href="mailto:feedback@carefulclues.com">feedback@carefulclues.com</a>
		</span>
		<div class="actions">
			<!--
				<Audio />
			-->

			{#if screenfull.isEnabled}
				<button
					class="full-screen-btn"
					on:click={() => screenfull.isEnabled && screenfull.toggle()}
					on:touchend|preventDefault={() => console.log('TOUCH!', screenfull.isEnabled) || screenfull.isEnabled && screenfull.toggle()}>
						{#if !isFullscreen}
							fullscreen
						{:else}
							exit fullscreen
						{/if}
				</button>
			{/if}
		</div>
	</footer>
</main>

<style lang="less">
	@import "./variables.less";

	:global(html), :global(body) {
		font-size: 1vmin;
	}

	:global(input), :global(button) {
		border-width: 0.15em;
		border-radius: 0.4em;
		background: rgba(255, 255, 255, 0.9);
		outline: 0;
		&:focus {
			border-color: #111111;
		}
	}

	:global(input[type=radio]) {
		width: 0.8em;
		height: 0.8em;
	}
	:global(button) {
		position: relative;
		padding: 0.5em 0.9em;
		margin: 0;
		font-size: inherit;
		line-height: 100%;
		color: white;
		background: #ffbc00;
		border-color: #ffffff;
		border-style: outset;
		border-width: 0.1em;
		outline: 0;

		&:active, &:focus, &:hover {
			box-shadow: 0 0 1em #ffbc00;
		}

		&:active {
			border-style: inset;
		}

		&:focus {
			border-color: #aaaaaa;
		}

		&:disabled, &[disabled] {
			opacity: 0.3;
		}

		&.white-button {
			color: #111111;
			background: white;
			vertical-align: middle;
			box-shadow: 0 0 1px #333333;

			&:active, &:focus, &:hover {
				box-shadow: 0 0 0.1em #333333;
			}
			&:active {
				border-width: 0.2em;
			}
		}
	}

	main {
		display: grid;
		width: 100vw; height: 100vh; max-width: 100vw; max-height: 100vh;
		grid-template-columns: 1fr 80em 1fr;
		grid-template-rows: 0.7fr auto 58em auto 1fr auto;
		gap: 3vmin 0;
		grid-template-areas:
			"header header header"
			"clue-left clue clue-right"
			"one core two"
			"msg msg msg"
			"chat-left chat chat-right"
			"footer footer footer";
		overflow: hidden;

		&.dynamic {
			grid-template-columns: 1fr max-content 1fr;
			grid-template-rows: 0.7fr auto max-content auto 1fr;
			gap: 0;
		}

		@media (@max-width-for-board) {
			grid-template-columns: 1fr 63em 1fr;
			&.dynamic {
				grid-template-columns: 1fr max-content 1fr;
			}
		}

		@media (@aspect-ratio) {
			grid-template-columns: 1fr 1fr;
			grid-template-rows: 1fr auto auto 58em auto minmax(33em, auto) 5fr auto;
			gap: 3vmin 0;
			grid-template-areas:
				"header header"
				"clue-left clue-right"
				"clue clue"
				"core core"
				"msg msg"
				"one two"
				"chat chat"
				"footer footer";
			font-size: 1.2em;
			&.dynamic {
				grid-template-columns: 1fr 1fr;
				grid-template-rows: 1fr auto max-content auto minmax(33em, auto) 5fr;
			}
		}

		& > * {
			transition: opacity 1s;
		}

		&.focusHero {
			& > * {
				opacity: 0;
			}
		}

		.core {
			grid-area: core;
			display: flex;
			width: 100%; height: 100%;
			justify-content: center;
			align-items: center;

			@media (@aspect-ratio) {
				padding: 1em;
				justify-self: center;
			}
		}

		.header {
			grid-area: header;

			.logo-link {
				position: absolute;
				display: inline-block;
				margin: 2vmin 0 0 2vmin;

				img {
					width: 7vmin;
				}
			}
		}

		.clue {
			display: flex;
			width: 100%;
			grid-area: clue;
			justify-content: center;
			align-items: center;
			align-self: flex-end;
		}

		.clue-left, .clue-right {
			display: flex;
			width: 100%;
			justify-content: center;
			align-items: flex-end;
			font-size: 2.5em;
			color: white;
		}
		.clue-left {
			grid-area: clue-left;
			padding-left: 1vmin;
			justify-content: flex-end;
			@media (@aspect-ratio) {
				right: -2em;
			}
		}

		.clue-right {
			grid-area: clue-right;
			padding-right: 1vmin;
			justify-content: flex-start;
			@media (@aspect-ratio) {
    			left: -1.4em;
			}
		}

		.team {
			display: flex;
			width: 100%; height: 100%;
			align-items: center;

			@media (@aspect-ratio) {
				height: auto;
				align-items: flex-start;
			}

			&.one {
				grid-area: one;
				justify-content: flex-end;
				text-align: right;

				@media (@aspect-ratio) {
					justify-content: flex-end;
				}
			}
			&.two {
				grid-area: two;
				justify-content: flex-start;
				text-align: left;

				@media (@aspect-ratio) {
					justify-content: flex-start;
				}
			}
		}

		.msg {
			display: flex; z-index: 10;
			width: 100%; height: 100%;
			grid-area: msg;
			justify-content: center;
			align-items: flex-start;
		}

		.chat {
			display: flex; z-index: 10;
			width: 100%; height: 100%;
			grid-area: chat;
			justify-content: center;
			align-items: flex-start;
			overflow: hidden;
		}

		footer {
			display: flex;
			grid-area: footer;
			justify-content: space-around;
    		align-items: flex-end;
			width: 100%;
			padding: 0 2rem 2rem 2rem;
			font-size: 1.3em;

			.image-credit, .copyright {
				color: #dddddd;
				font-style: italic;
				font-size: 1em;
				text-shadow: 0 0 1px black;
				@media (@aspect-ratio) {
					font-size: 1.4em;
				}
			}

			.copyright {
				font-size: 1.1em;
				@media (@aspect-ratio) {
					font-size: 1.5em;
				}
			}

			.actions {
				font-size: 1.7em;
				button {
					color: white;
					background: none;
					text-shadow: 0 0 2px black;
				}
			}

			.full-screen-btn {
				font-size: 0.7em;
			}
		}
	}

	:global(.colorcycle) {
		animation: colorcycle 500ms infinite;
	}
	@keyframes -global-colorcycle {
		0% {
			background-color: #ffbc00;
		}
		25% {
			background-color: rgba(20, 20, 20, 1);
		}
		50% {
			background-color: rgba(190, 190, 180, 1);
		}
		75% {
			background-color: rgba(30,130,255);
		}
		100% {
			background-color: rgba(255,0,204, 1);
		}
	}

	:global(.pulse) {
		animation: pulse 2s infinite;
		animation-timing-function: ease-in;
	}
	:global(.fast-pulse) {
		animation: pulse 750ms infinite;
		animation-timing-function: ease-in;
	}
	@keyframes -global-pulse {
		0% {
			opacity: 1;
		}
		50% {
			opacity: 0.55;
		}
		100% {
			opacity: 1;
		}
	}

</style>